import { default as firebase } from "common/Firebase";
import { FirebaseDocument } from "common/models/FirebaseDocument";
import { firestore } from "common/Firebase";
import { RateLibraryTasks } from "modules/activitySearch/models/RateLibraryTasks";
import { ProfileService } from "modules/profile/ProfileService";
import { LoginStore } from "modules/login/LoginStore";
import { TDocumentChange } from "common/types/FirebaseTypes";

class Service {
  /** Inscreve o snapshot nos bancos de composições em que o usuário logado
   * possui acesso. A lista de documentos é provida para a função callback.
   */
  fetchRateLibrariesFromFirebase(callback: (docs: TDocumentChange[]) => void) {
    const userId = ProfileService.getUserId();

    LoginStore.clearRateLibrariesSnapshot();
    if (userId) {
      LoginStore.rateLibrariesSnapshot = firestore
        .collection("rateLibraries")
        .where(`users.${userId}`, "<", 3)
        .onSnapshot(
          (snapshot) => {
            callback(snapshot.docChanges());
          },
          (error) => {
            console.error("Error on RateLibrary Snapshot", error);
          }
        );
    }
  }

  async fetchRateLibrariesTasks(
    rateLibraryId: string,
    search: string
  ): Promise<Array<FirebaseDocument<RateLibraryTasks>>> {
    let array = new Array<FirebaseDocument<RateLibraryTasks>>();
    let normalizeSearch = search
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
    let arrayString = normalizeSearch.split(" ");

    let snapshot = await firestore
      .collection("rateLibraryTasks")
      .orderBy("description")
      .where("file.id", "==", rateLibraryId)
      /* .startAt(search)
        .endAt(search+'\uf8ff') */
      .get();
    let arrayForReuse = new Array<FirebaseDocument<RateLibraryTasks>>();

    for (let doc of snapshot.docs) {
      let data = doc.data();
      if (data) {
        let normalizeDescription = data.description
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase();
        let arrayFind = true;
        for (let i = 0; i < arrayString.length; i++) {
          if (normalizeDescription.indexOf(arrayString[i]) < 0) {
            arrayFind = false;
          }
        }

        let task = new RateLibraryTasks(
          data.class,
          data.code,
          data.composition,
          data.description,
          data.descriptionGroup,
          data.alternativeCodeComposition,
          data.alternativeCodeItem,
          data.equipmentCost,
          data.equipmentCostPecentage,
          data.laborCost,
          data.laborCostPercenage,
          data.level,
          data.link,
          data.materialCost,
          data.materialCostPercentage,
          data.otherCost,
          data.otherCostPercentage,
          data.priceRise,
          data.thirdPartyServiceCost,
          data.thirdPartyServiceCostPercentage,
          data.totalCost,
          data.type,
          data.unity,
          data.file,
          data.compositionList
        );
        arrayForReuse.push(
          new FirebaseDocument<RateLibraryTasks>(doc.id, task)
        );
        if (arrayFind) {
          array.push(new FirebaseDocument<RateLibraryTasks>(doc.id, task));
        }
      }
    }

    return array;
  }

  async fetchRateLibrariesTasksClient(
    rateLibraryId: string,
    content: string
  ): Promise<Array<FirebaseDocument<RateLibraryTasks>>> {
    let snapshot = await firestore
      .collection("rateLibraryTasks")
      .orderBy("description")
      .where("file.id", "==", rateLibraryId)
      .get();

    let array = new Array<FirebaseDocument<RateLibraryTasks>>();
    let normalize = content
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();

    for (let doc of snapshot.docs) {
      let data = doc.data();
      if (data) {
        let normalizeDescription = data.description
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase();
        if (normalizeDescription.indexOf(normalize) >= 0) {
          let task = new RateLibraryTasks(
            data.class,
            data.code,
            data.composition,
            data.description,
            data.descriptionGroup,
            data.alternativeCodeComposition,
            data.alternativeCodeItem,
            data.equipmentCost,
            data.equipmentCostPecentage,
            data.laborCost,
            data.laborCostPercenage,
            data.level,
            data.link,
            data.materialCost,
            data.materialCostPercentage,
            data.otherCost,
            data.otherCostPercentage,
            data.priceRise,
            data.thirdPartyServiceCost,
            data.thirdPartyServiceCostPercentage,
            data.totalCost,
            data.type,
            data.unity,
            data.file,
            data.compositionList
          );
          array.push(new FirebaseDocument<RateLibraryTasks>(doc.id, task));
        }
      }
    }

    return array;
  }

  async getRateLibraryTaskById(id: string) {
    let activity = await firestore.collection("rateLibraryTasks").doc(id).get();
    let data = activity.data();
    if (data) {
      let fileModel = new RateLibraryTasks(
        data.class,
        data.code,
        data.composition,
        data.description,
        data.descriptionGroup,
        data.alternativeCodeComposition,
        data.alternativeCodeItem,
        data.equipmentCost,
        data.equipmentCostPecentage,
        data.laborCost,
        data.laborCostPercenage,
        data.level,
        data.link,
        data.materialCost,
        data.materialCostPercentage,
        data.otherCost,
        data.otherCostPercentage,
        data.priceRise,
        data.thirdPartyServiceCost,
        data.thirdPartyServiceCostPercentage,
        data.totalCost,
        data.type,
        data.unity,
        data.file,
        data.compositionList
      );
      return new FirebaseDocument<RateLibraryTasks>(activity.id, fileModel);
    }
    return null;
  }

  async getRateLibraryTaskByArrayIds(userIDs, tasksList): Promise<any> {
    let models = new Array();
    let size = 10;
    let idToDelete: any = [];
    for (let i = 0; i < userIDs.length; i++) {
      let taskIndex = tasksList.findIndex(
        (tl) => tl.id == userIDs[i].reference
      );
      if (taskIndex != -1) {
        idToDelete.push(i);
        models.push({
          parentTask: userIDs[i].parentTask,
          data: tasksList[taskIndex].data,
        });
      }
    }
    for (let i = idToDelete.length - 1; i >= 0; i--) {
      userIDs.splice(idToDelete[i], 1);
    }
    let userIDsRef = userIDs.map((ui) => ui.reference);
    // Cria um batch de 10 elementos para não aparecer o erro "filters support a maximum of 10 elements"
    for (let i = 0; i < userIDsRef.length; i += size) {
      // Efetua a query pelos ids do laço de repetição
      const snap = await firestore
        .collection("rateLibraryTasks")
        .where(
          firebase.firestore.FieldPath.documentId(),
          "in",
          userIDsRef.slice(i, i + size)
        )
        .get();
      for (let doc of snap.docs) {
        let data: any = doc.data();
        let id = doc.id;
        if (data) {
          let fileModel = new RateLibraryTasks(
            data.class,
            data.code,
            data.composition,
            data.description,
            data.descriptionGroup,
            data.alternativeCodeComposition,
            data.alternativeCodeItem,
            data.equipmentCost,
            data.equipmentCostPecentage,
            data.laborCost,
            data.laborCostPercenage,
            data.level,
            data.link,
            data.materialCost,
            data.materialCostPercentage,
            data.otherCost,
            data.otherCostPercentage,
            data.priceRise,
            data.thirdPartyServiceCost,
            data.thirdPartyServiceCostPercentage,
            data.totalCost,
            data.type,
            data.unity,
            data.file,
            data.compositionList
          );

          for (let j = 0; j < userIDs.length; j++) {
            if (userIDs[j].reference == id) {
              models.push({
                parentTask: userIDs[j].parentTask,
                data: fileModel,
              });
              tasksList.push({ id: doc.id, data: fileModel });
              break;
            }
          }
        }
      }
    }
    return models;
  }
}

let ActivitySearchService = new Service();
export { ActivitySearchService };



// WEBPACK FOOTER //
// ./src/modules/activitySearch/ActivitySearchService.tsx